import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {finalize, Observable, throwError} from 'rxjs';
import {catchError, timeout} from 'rxjs/operators';
import {Store} from '@ngxs/store';
import {Logout, RefreshLogin} from '@shared/store/auth/auth.actions';
import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {LoadingService} from '@shared/services/loading.service';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  timeoutValue = 1000000000;

  constructor(
    private store: Store,
    private snackbar: MatSnackBar,
    private loading: LoadingService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const excludedRoutes = [
      'external/terminalActivity',
      'assets/icons/flags',
    ];

    const trackLoader = !excludedRoutes.some(route => req.url.includes(route));

    if (trackLoader) {
      this.loading.showLoader();
    }

    if (req.url.includes('import')) {
      this.timeoutValue = 1000000000;
    }

    return next.handle(req).pipe(
      timeout(this.timeoutValue),
      finalize(() => {
        if (trackLoader) {
          this.loading.hideLoader();
        }
      }),
      catchError((error) => {
        if (error.status === 401) {
          this.snackbar.open('Ihre Sitzung ist abgelaufen');
          this.store.dispatch(Logout);
        }
        if (error.status === 500 && (req.method === 'PUT' || req.method === 'POST')) {
          this.snackbar.open('Ein Fehler ist aufgetreten');
        }
        return throwError(() => error.message);
      })
    );
  }

}
